import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import { AUTH_ROUTES as AUTH_ROUTE_CONSTANTS } from '../route-constants';
import AuthRoutesWrapper from '../wrappers/auth-routes-wrapper';

const ResetPassword = lazy(() => import('@~/screens/reset-password'));
const LoginPage = lazy(() => import('@~/pages/login-v2/login'));
const ForgotPasswordPage = lazy(() => import('@~/pages/forgot-password/forgot-password'));
const SignupPage = lazy(() => import('@~/pages/signup/signup'));
const SignupLpPage = lazy(() => import('@~/pages/parent/signup-lp/signup-lp'));
const SignupUnavailable = lazy(
  () => import('@~/pages/signup-unavailable/signup-unavailable'),
);

export const AUTH_ROUTES: RouteObject = {
  element: <AuthRoutesWrapper />,
  children: [
    {
      path: AUTH_ROUTE_CONSTANTS.RESET_PASSWORD.PATH,
      element: <ResetPassword />,
      handle: {
        pageName: AUTH_ROUTE_CONSTANTS.RESET_PASSWORD.NAME,
      },
    },
    {
      path: AUTH_ROUTE_CONSTANTS.LOGIN.PATH,
      element: <LoginPage />,
      handle: {
        pageName: AUTH_ROUTE_CONSTANTS.LOGIN.NAME,
      },
    },
    {
      path: AUTH_ROUTE_CONSTANTS.FORGOT_PASSWORD.PATH,
      element: <ForgotPasswordPage />,
      handle: {
        pageName: AUTH_ROUTE_CONSTANTS.FORGOT_PASSWORD.NAME,
      },
    },
    {
      path: AUTH_ROUTE_CONSTANTS.SIGNUP_UNAVAILABLE.PATH,
      element: <SignupUnavailable />,
      handle: {
        pageName: AUTH_ROUTE_CONSTANTS.SIGNUP_UNAVAILABLE.NAME,
      },
    },
    {
      path: AUTH_ROUTE_CONSTANTS.SIGNUP.PATH,
      element: <SignupPage />,
      handle: {
        pageName: AUTH_ROUTE_CONSTANTS.SIGNUP.NAME,
      },
    },
    {
      path: AUTH_ROUTE_CONSTANTS.SIGNUP_LP.PATH,
      element: <SignupLpPage />,
      handle: {
        pageName: AUTH_ROUTE_CONSTANTS.SIGNUP_LP.NAME,
      },
    },
  ],
};
